import { JuvoTrackSession } from '@core/domain/local-channel';

export function hasStockChannel(localChannelSession: JuvoTrackSession | null): boolean {
	return (localChannelSession?.length ?? 0) > 0;
}
